export default __webpack_public_path__ + "static/media/bg_1.b666736f.mp4";